module.exports = __webpack_public_path__ + "img/imageGalery9.86bf3c1b.jpeg";